import { HTML_LANG, LANGUAGES, LANGUAGE_NAMES, Language } from '../constants';

interface LangToggleProps {
  value: Language;
  onChange: (lang: Language) => void;
}

export function LangToggle({ value, onChange }: LangToggleProps) {
  return (
    <div className="inline-flex border border-stone-900 font-mono text-[10px] tracking-[0.12em] uppercase">
      {LANGUAGES.map((lang, index) => (
        <button
          key={lang}
          onClick={() => onChange(lang)}
          aria-label={LANGUAGE_NAMES[lang]}
          aria-pressed={lang === value}
          lang={HTML_LANG[lang]}
          className={`
            appearance-none border-0 py-1.5 px-2.5 min-h-6 cursor-pointer font-mono text-[10px] tracking-[0.12em] uppercase
            ${index !== LANGUAGES.length - 1 ? 'border-r border-stone-900' : ''}
            ${lang === value ? 'bg-stone-900 text-stone-50 font-bold underline decoration-1 underline-offset-4' : 'bg-transparent text-stone-900'}
          `}
        >
          {lang}
        </button>
      ))}
    </div>
  );
}
